import { registerBlockType } from '@wordpress/blocks'
import { Path, Rect, SVG } from '@wordpress/components'
import { select } from '@wordpress/data'
import { RichText } from '@wordpress/block-editor'
import MetaPhoto from '../Meta/MetaPhoto'
import { store as editorStore } from '@wordpress/editor'


registerBlockType('usna1978/classmate-about', {
  title: 'Classmate: About',
  description: 'Add profile images and a summary for the classmate.',
  // eslint-disable-next-line react/jsx-pascal-case
  icon: <SVG viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><Path d='M0,0h24v24H0V0z' fill='none' /><Path d='M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,18H4V6h16V18z' /><Rect x='6' y='10' width='2' height='2' /><Rect x='6' y='14' width='8' height='2' /><Rect x='16' y='14' width='2' height='2' /><Rect x='10' y='10' width='8' height='2' /></SVG>,
  category: 'formatting',
  attributes: {
    aboutDetails: {
      type: 'string',
      source: 'meta',
      selector: 'p',
      meta: 'usna1978_personal_paragraph'
    },
    aboutImage1: {
      type: 'string',
      source: 'meta',
      selector: 'img.graduation-photo',
      meta: 'usna1978_graduation_photo'
    },
    aboutImage2: {
      type: 'string',
      source: 'meta',
      selector: 'img.current-photo',
      meta: 'usna1978_current_photo'
    },
    pageId: {
      type: 'number'
    }
  },

  /**
   * The edit function describes the structure of your block in the context of
   * the editor. This represents what the editor will render when the block is
   * used.
   *
   * The "edit" property must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  edit: ({ state, attributes, setAttributes }) => {
    const { aboutDetails } = attributes
    const getCurrentPostID = () => {
      return select(editorStore).getCurrentPostId()
    }

    setAttributes({
      pageId: getCurrentPostID(state)
    })

    return (
      <div className='panel panel-default'>
        <div className='panel-heading'>
          <strong>About</strong>
        </div>
        <div className='panel-body'>
          <div className='image-grid'>
            <MetaPhoto
              fieldName='usna1978_graduation_photo'
              label='Graduation Photo'
            />
            <MetaPhoto
              fieldName='usna1978_current_photo'
              label='Current Photo'
            />
          </div>
          <RichText
            tag='p'
            value={aboutDetails}
            onChange={content => setAttributes({ aboutDetails: content })}
            placeholder='Add details about this classmate...'
          />
        </div>
      </div>
    )
  },

  /**
   * The save function defines the way in which the different attributes should
   * be combined into the final markup, which is then serialized by Gutenberg
   * into post_content.
   *
   * The "save" property must be specified and must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  save () {
    return null
  }
})
